import React, { useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import FormSwitch from 'jd-library/FormSwitch';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import SliderWrapper from 'jd-library/SliderWrapper';
import ButtonGroup from 'jd-library/ButtonGroup';
import { showMessage } from "jd-library/src/Toast/ToastAction";
import NoProductFound from '../../no-product-found/NoProductFound';
import Loader from '../../Loader/Loader';
import ImageLoader from '../../Image/ImageLazyWrapper';
import UOMSliderWrapper from '../../../pages/add-edit-product/UOMSliderWrapper';
import Button from '../../Button/Button';
import { getListingData, toggleOutDatedProductCardSlider,getPsvDetails } from '../../../actions/products';
import styles from "./index.scss";
import { Regex, isBeyondRange } from '../../../utills';
import { setNotificationData } from '../../../pages/listing/Notifications/redux/action';
import { debounceFunc, updateOutdatedPriceCardData } from './utils';
import UnitCount from '../../../pages/add-edit-product/unit-Count/UnitCount';

const NoImageForTemplate = (props) => {
  const imageProps = {
    style: {
      borderRadius: '10px'
    },
    imgClass: styles['no-img-image'],
    finalImageSrc: "https://image1.jdomni.in/jdomni_email/NOIMAGE_2002211157.png",
    retainRandomColor: true,
  }
  return (
    <div className="no-img template-product imgHolder" onClick={() => {
      props.onClick && props.onClick()
    }}>
      <ImageLoader {...imageProps} />
    </div>
  );
};

const OutDatedPriceCard = ({ session }) => {

  const sliderRef = useRef(null);
  const selectedSlider = useRef(null);
  const dispatch = useDispatch();
  const outDatedPricecardData = useSelector(state => state.products.outDatedPricecardData)
  const filterProductObj = useSelector(state => state.products.filterProductObj)  
  const isReadOnly = useSelector(state => state.session.isReadOnly);
  
  const uomDefaultOBj =  useSelector( state=> state.uom?.serviceUOM.filter(x=> x.val == "Sess")[0])
  const [prodData, setProdData] = useState(outDatedPricecardData || [])
  const [isDataSet, updateDataSet] = useState(false);
  const [currentSelectedForUom, setCurrentSelectedForUom] = useState(0)
  const [productUnderEdit,setProductUnderEdit] = useState(null); 
  const [scroll, setScroll] = useState(0)
  const mainUOM = useSelector(state => state.uom)
  uomDefaultOBj.count = "1"

  useEffect(() => {
    setProdData(outDatedPricecardData || [])
  }, [outDatedPricecardData])

  const toggleChange = (value, index) => {
    if(isReadOnly) return;
    const updatedValues = [...prodData];
    if (value) {
      updatedValues[index].showPriceRange = true;
      if (updatedValues[index].uom?.val == 'stds'){
        onSelectUOM('', uomDefaultOBj)
        uomChange('1',index,'1 Sess')
      }
    } else {
      updatedValues[index].showPriceRange = false;
      if(updatedValues[index].categoryType != "product"){
        updatedValues[index].error = '';
      }
    }
    setProdData([...updatedValues]);
  }

  const onChange = (e, key, isMinMax, actDisc) => {
    const { target: { value } } = e;
    if (Regex.priceRegex.test(value)) {
      let values = [...prodData];
      let price = values[key]?.priceObj ? { ...values[key]?.priceObj } : {};
      if (isMinMax) {
        if (isMinMax === 'min') {
          price = {
            ...price,
            minPrice: value
          };
        } else {
          price = {
            ...price,
            maxPrice: value
          };
        }
      } else if (actDisc) {
        if (actDisc == 'act') {
          values[key].actualPrice = value;
        } else {
          values[key].discPrice = value;
        }
      } else {
        values[key].price = value;
      }

      if (!isMinMax) {
        values[key].error = '';
      } else if (isMinMax === 'min' || isMinMax === 'max') {
        price = {
          ...price,
          minError: '',
          maxError: ''
        }
      }
      if (actDisc) {
        values[key].actualPriceErr = '';
        values[key].discPriceErr = '';
      } 
      values[key].priceObj = price;
      setProdData([...values]);
    }
  }

  const onSelectUOM = (_, uom) => {
    if (selectedSlider.current !== null) {
      const values = [...prodData];
      values[selectedSlider.current].uom = uom;
      if(values[selectedSlider.current].showPriceRange){
        values[selectedSlider.current].priceObj.minError = '';
        values[selectedSlider.current].priceObj.maxError = '';
      }
      setProdData([...values])
      sliderRef.current?.openCloseUOMSlider(false);
    }
  }

  const validatePrice = (productdata, isUpdatePrice) => {
    let validated = 1;
    let errMsg = '';
    if (!isUpdatePrice) {
      return { validated, errMsg, productdata }
    }
    if (productdata.showPriceRange && !productdata.priceObj.minPrice) {
      productdata.priceObj.minError = 'Please enter Min Price';
      productdata.priceObj.maxError = productdata.priceObj.maxPrice === '0' || productdata.priceObj.maxPrice === '1' || !productdata.priceObj.maxPrice ? ' ' : ''
      errMsg = errMsg || 'Please enter Min Price';
      validated = 0;
    } else if (productdata.showPriceRange && productdata.priceObj.minPrice === '0') {
      productdata.priceObj.minError = 'Minimum price Cannot be 0';
      productdata.priceObj.maxError = productdata.priceObj.maxPrice === '0' || productdata.priceObj.maxPrice === '1' || !productdata.priceObj.maxPrice ? ' ' : ''
      errMsg = errMsg || 'Minimum price Cannot be 0';
      validated = 0;
    } else if (productdata.showPriceRange && productdata.priceObj.minPrice && Number(productdata.priceObj.minPrice) < 0.01) {
      productdata.priceObj.minError = 'Minimum price must be at least 0.01';
      productdata.priceObj.maxError = productdata.priceObj.maxPrice === '0' || productdata.priceObj.maxPrice === '1' || !productdata.priceObj.maxPrice ? ' ' : ''
      errMsg = errMsg || 'Minimum price must be at least 0.01';
      validated = 0;
    } else if (productdata.showPriceRange && !productdata.priceObj.maxPrice) {
      productdata.priceObj.maxError = 'Please enter Max Price';
      productdata.priceObj.minError = productdata.priceObj.minPrice === '0' || productdata.priceObj.minPrice === '1' ? ' ' : ''
      errMsg = errMsg || 'Please enter Max Price';
      validated = 0;
    } else if (productdata.showPriceRange && productdata.priceObj.maxPrice === '0') {
      productdata.priceObj.maxError = 'Maximum price Cannot be 0';
      productdata.priceObj.minError = productdata.priceObj.minPrice === '0' || productdata.priceObj.minPrice === '1' ? ' ' : ''
      errMsg = errMsg || 'Maximum price Cannot be 0';
      validated = 0;
    } else if (productdata.showPriceRange && productdata.priceObj.maxPrice && Number(productdata.priceObj.maxPrice) < 0.01) {
      productdata.priceObj.maxError = 'Maximum price must be at least 0.01';
      errMsg = errMsg || 'Maximum price must be at least 0.01';
      validated = 0;
    } else if (productdata.showPriceRange && productdata.priceObj.minPrice && productdata.priceObj.maxPrice && Number(productdata.priceObj.minPrice) >= Number(productdata.priceObj.maxPrice)) {
      productdata.priceObj.maxError = ' ';
      productdata.priceObj.minError = ' ';
      errMsg = errMsg || 'Maximum Price Cannot be Same or Less Than Minimum Price';
      validated = 0;
    } else if (productdata.showPriceRange && (productdata.priceObj.maxError || productdata.priceObj.minError)) {
      errMsg = errMsg || productdata.priceObj.minError || productdata.priceObj.maxError;
      validated = 0;
    } else if (productdata?.showPriceRange && productdata?.error){
        validated = 1;
    }else if (!productdata.showPriceRange) {
      if (productdata.price && Number(productdata.price) == 0) {
        productdata.error = errMsg || 'Cannot be 0';
        errMsg = errMsg || 'Price Cannot be 0';
        validated = 0;
      } else if (productdata.price && Number(productdata.price) < 0.01) {
        productdata.error = errMsg || 'Price must be at least 0.01';
        errMsg = errMsg || 'Price must be at least 0.01';
        validated = 0;
      }

      if (productdata.actualPrice && Number(productdata.actualPrice) == 0) {
        productdata.actualPriceErr = errMsg || 'Actual Price Cannot be 0';
        errMsg = errMsg || 'Actual Price Cannot be 0';
        validated = 0;
      } else if (productdata.actualPrice && Number(productdata.actualPrice) < 0.01) {
        productdata.actualPriceErr = errMsg || 'Actual Price must be at least 0.01';
        errMsg = errMsg || 'Actual Price must be at least 0.01';
        validated = 0;
      } else {
        productdata.actualPriceErr = ""
      }

      if (productdata.discPrice && Number(productdata.discPrice) == 0) {
        productdata.discPriceErr = errMsg || 'Discount Price Cannot be 0';
        errMsg = errMsg || 'Discount Price Cannot be 0';
        validated = 0;
      } else if (productdata.discPrice && Number(productdata.discPrice) < 0.01) {
        productdata.discPriceErr = errMsg || 'Discount Price must be at least 0.01';
        errMsg = errMsg || 'Discount Price must be at least 0.01';
        validated = 0;
      } else {
        productdata.discPriceErr = ""
      }

      if (productdata.actualPrice && productdata.discPrice && Number(productdata.discPrice) > Number(productdata.actualPrice)) {
        productdata.actualPriceErr = errMsg || 'Disc.Rs. cannot be greater than Actual Rs.';
        productdata.discPriceErr = errMsg || 'Disc.Rs. cannot be greater than Actual Rs.';
        errMsg = errMsg || 'Discount Price cannot be greater than Actual Price';
        validated = 0;
      }
    } else if (productdata.error) {
      validated = 0;
      errMsg = errMsg || productdata.error;
    }
    if (validated) {
      if (productdata.categoryType == 'service' && productdata.actualPrice && !productdata.discPrice) {
        productdata.discPrice = productdata.actualPrice
      } else if (productdata.categoryType == 'service' && productdata.discPrice && !productdata.actualPrice) {
        productdata.actualPrice = productdata.discPrice
      }
    } else if(productdata.categoryType == 'service' && validated == 1) {
      errMsg = productdata.priceObj.minError = productdata.priceObj.maxError = '';
    }
    return { validated, errMsg, productdata }
  }

  const handleSubmit = async (isUpdatePrice, ind) => {
    const allProductData = [...prodData];
    const currentProdData = allProductData[ind];
    const { validated, errMsg, productdata } = validatePrice(currentProdData, isUpdatePrice)
    allProductData[ind] = productdata;
    if (!validated) {
      setProdData([...allProductData]);
      dispatch(showMessage({
        showToastMessage: true,
        message: errMsg,
        type: 'error',
        duration: 2000
      }))
    } else {
      const isLastProd = allProductData.length == 1
      const { success, error, errData=null } = await updateOutdatedPriceCardData(currentProdData, isUpdatePrice, isLastProd);
      let msg = `Price Updated Successfully For ${currentProdData.productName}`
      if(!isUpdatePrice){
        msg = "Price saved as it is"
      }
      if (success) {
        dispatch(showMessage({
          showToastMessage: true,
          message: msg,
          type: 'info',
          duration: 2000
        }));
        dispatch(getListingData({ tabKey: undefined, filterObj: filterProductObj }))
      } else {
        if (['service','product'].includes(currentProdData.categoryType) && ['productPriceTollerence','servicePriceTollerence'].includes(errData.errorType)) {        
          const priceErrData = errData?.priceRange[0]; 
          if (currentProdData?.showPriceRange) {
            if (isBeyondRange(currentProdData?.priceObj?.minPrice, priceErrData?.minPrice, priceErrData?.maxPrice)) {
              currentProdData.priceObj.minError = errData?.msg
            }
            if(isBeyondRange(currentProdData?.priceObj?.maxPrice, priceErrData?.minPrice, priceErrData?.maxPrice)) {
              currentProdData.priceObj.maxError = currentProdData?.priceObj?.minError ? ' ' : errData?.msg;
            }
          } else {
            if (currentProdData.price){
                if (isBeyondRange(currentProdData?.price, priceErrData?.minPrice, priceErrData?.maxPrice)) {
                currentProdData.error = errData?.msg;
              }
            }else{
              if (isBeyondRange(currentProdData?.actualPrice, priceErrData?.minPrice, priceErrData?.maxPrice)) {
                currentProdData.actualPriceErr = errData?.msg;
              }
              if (isBeyondRange(currentProdData?.discPrice, priceErrData?.minPrice, priceErrData?.maxPrice)) {
                currentProdData.discPriceErr = currentProdData?.actualPriceErr ? ' ' : errData?.msg;
              }    
            }
          }
          allProductData[ind] = currentProdData;
          setProdData([...allProductData]);
        }
        dispatch(showMessage({
          showToastMessage: true,
          message: error,
          type: 'error',
          duration: 2000
        }));
      }
      dispatch(setNotificationData({ token: session?.token }));
    }
  }

  const uomChange = (value, ind, uomString) => {
    const count = value || 1
    const values = [...prodData];
    values[ind].customDuration = values[ind]?.uom?.val != 'stds' ? values[ind]?.uom?.val : uomString.split(" ")[1];
    values[ind].customUnit = count;
    values[ind].uom.count = count;
    values[ind].unitOfMeasurement = `${count} ${uomString.split(" ")[1]}`
    setProdData([...values])
  }

  const isUomVisible = (pricedata) => {
    const uomTypeAry = ["Session", "Visit", "Session(s)", "Visit(s)", "Specific Time Duration", "Specific Time Duration(s)"]
    const uomTypeArr = ["Sess", "visit", "stds"]
    // One for condition is here that is only for services that need to be handle using api
    if (uomTypeAry.includes(pricedata?.uom?.displayVal) || uomTypeArr.includes(pricedata?.customUnit)) {
      return true
    } else {
      return false
    }
  }

  const uomFull = (val) => {
    if (val.toLowerCase() == 'sess') return "Session"
    else if (val.toLowerCase() == 'visit') return "Visit"
    else if (val.toLowerCase() == 'stds') return "Specific Time Duration"
    else return ""
  }

  const closeSlider = async () => {
    const { default: { closeCurrent } } = await import('jd-library/historyHandler');
    dispatch(toggleOutDatedProductCardSlider(false))
    setTimeout(() => closeCurrent(), 100);
  }

  const scrollHandler = (e) => {
    if((scroll < 10 && e.target.scrollTop > 10) || e.target.scrollTop == 0){
      setScroll(e.target.scrollTop);
    }
  }

  const debouncedScrollHandler = debounceFunc(scrollHandler, 10);

  useEffect(() => {
    if(prodData?.length && !isDataSet) {
      let newData = prodData.map(cur => {
        checkAndFillUOM(cur);
        return cur;
      })
      setProdData(newData);
      updateDataSet(true);
    }
  },[prodData])

  const checkAndFillUOM = (pricedata) => {
    if(pricedata.uom) {
      let psvData = {
        type: pricedata.categoryType,
        psv_node_id: pricedata.psv_node_id,
      };
      let PsvDetailsUomType = dispatch(getPsvDetails(psvData));
      if(PsvDetailsUomType?.UNIT?.length) {
        pricedata.PsvDetailsUomType =  PsvDetailsUomType;
        let uomInPsvData = PsvDetailsUomType?.UNIT?.length ? PsvDetailsUomType.UNIT.find(cur => cur.val == pricedata.uom.val) : null;
        if(!uomInPsvData) {
          pricedata.uom = PsvDetailsUomType?.UNIT[0];
        }
      }
    }
  }


  return (
    <SliderWrapper
      header={{
        heading: 'Update Price',
        className: ` ${scroll > 10 ? "header-scrolled" : ""}`
      }}
      footer={{}}
      onHidden={async () => {
        dispatch(toggleOutDatedProductCardSlider(false));
      }}
      onScroll={debouncedScrollHandler}
    >
      {!prodData ? <Loader /> :
        <div className="outDated-price-card-container">
          {
            prodData?.length ? prodData?.map((item, i) => {
              const isErrClass = item.error || item?.actualPriceErr || item?.discPriceErr || item?.priceObj?.minError || item?.priceObj?.maxError
              return (
                <div key={item.productId} className="card-item-container">
                  <div className="card-item">
                    {item.imageUrl.includes('http') ?
                      <div className='image-container'>
                        <img src={item.imageUrl} alt="" />
                      </div>
                      : <div className='img-holder image-place-holder'><div className='no-img imgHolder'><NoImageForTemplate /></div></div>}
                    <div className="product-data-container">
                      <div className="product-name">{item.productName}</div>
                      <div className='inputgroup'>
                        {item.showPriceRange ?
                          <>
                            <InputWithMovingLabel
                              label='Min Rs.'
                              errClass="errClass"
                              errorMessage={item?.priceObj?.minError || item?.priceObj?.maxError}
                              input={{
                                value: item?.priceObj?.minPrice || '',
                                type: 'text',
                                maxlength: 50,
                                onChange: (e) => onChange(e, i, 'min'),
                                className: "priceInp"
                              }}
                              holderClass={`priceContainer ${item?.priceObj?.minPrice ? "removeTop" : ""} ${!item?.priceObj?.minError && item?.priceObj?.maxError ? "addMaxErr" : ""} ${isReadOnly ? 'priceContainer-read-only-mode' : '' } `}
                            />
                            -
                            <InputWithMovingLabel
                              label='Max Rs.'
                              errClass="errClass"
                              errorMessage={item.priceObj?.maxError}
                              input={{
                                value: item?.priceObj?.maxPrice || '',
                                type: 'text',
                                maxlength: 50,
                                onChange: (e) => onChange(e, i, 'max'),
                                className: "priceInp"
                              }}
                              holderClass={`priceContainer ${item?.priceObj?.maxPrice ? "removeTop" : ""} ${item?.priceObj?.maxError ? "removeMaxErr" : ""} ${isReadOnly ? 'priceContainer-read-only-mode' : '' } `}
                            />
                          </>
                          : (item.categoryType == 'service') ?
                            <>
                              <InputWithMovingLabel
                                label='Act. Rs.'
                                errClass="errClass"
                                errorMessage={item?.actualPriceErr || item?.discPriceErr}
                                input={{
                                  value: item?.actualPrice,
                                  type: 'text',
                                  maxlength: 50,
                                  onChange: (e) => onChange(e, i, '', 'act'),
                                  className: "priceInp"
                                }}
                                holderClass={`priceContainer ${item?.actualPrice ? "removeTop" : ""} ${!item?.actualPriceErr && item?.discPriceErr ? "addMaxErr" : ""} ${isReadOnly ? 'priceContainer-read-only-mode' : '' }`}
                              />
                              <div className='act-disc-inBtwn' />
                              <InputWithMovingLabel
                                label='Disc.Rs.'
                                errClass="errClass"
                                errorMessage={item?.discPriceErr}
                                input={{
                                  value: item?.discPrice,
                                  type: 'text',
                                  maxlength: 50,
                                  onChange: (e) => onChange(e, i, '', 'disc'),
                                  className: "priceInp"
                                }}
                                holderClass={`priceContainer ${item?.discPrice ? "removeTop" : ""} ${item?.discPriceErr ? "removeMaxErr" : ""} ${isReadOnly ? 'priceContainer-read-only-mode' : '' }`}
                              />
                            </>
                            :
                            <InputWithMovingLabel
                              label='Price'
                              errClass="errClass"
                              errorMessage={item.error}
                              input={{
                                value: item?.price,
                                type: 'text',
                                maxlength: 50,
                                onChange: (e) => onChange(e, i),
                                className: "priceInp"
                              }}
                              holderClass={`priceContainer ${item?.price ? "removeTop" : ""} ${isReadOnly ? 'priceContainer-read-only-mode' : '' } `}
                            />
                        }
                        {" / "}
                        <InputWithMovingLabel
                          label='Unit'
                          disableMovingLabel
                          rightIconClass={isReadOnly ? '' :  item.isTemplate   ? "" : item.uom?.displayVal ? 'icon-HDRcross' : 'icon-Next'}
                          onRightIconClick={() => {
                            if (item.uom?.displayVal) {
                              let values = [...prodData];
                              values[i].uom = null;
                              selectedSlider.current = null;
                              setProdData([...values]);
                              setCurrentSelectedForUom(i);
                            } else {
                              selectedSlider.current = i;
                              sliderRef.current.openCloseUOMSlider(true);
                            }
                          }}
                          input={{
                            value: item?.uom?.displayVal || uomFull(item?.customUnit),
                            type: 'text',
                            readOnly: true,
                            maxlength: 100,
                            disabled: item.isTemplate ,
                            className: `unitInp ${item.isTemplate && "disablePointer"}`,
                            onClick: () => {
                              setProductUnderEdit(item);
                              selectedSlider.current = i;
                              sliderRef.current.openCloseUOMSlider(true);
                              setCurrentSelectedForUom(i);
                            }
                          }}
                          holderClass= {`unitContainer ${isReadOnly ? 'unitContainer-read-only-mode' : '' } `}
                        />
                      </div>
                      {
                        isUomVisible(item) ?
                          <div className={`uom-container ${isErrClass ? "errClassMTop" : ""} ${isReadOnly ? 'uom-container-read-only-mode' : ''} `}>
                            <UnitCount
                              uomDetails={item || ''}
                              showUnitCount={['Sess', 'Visit', 'stds'].includes(item.customUnit)}
                              customDuration={item.customDuration || ''}
                              isFromAddPrice={true}
                              isFromOutDatedPrice={true}
                              uomChange={(uom, index, uomString) => uomChange(uom, index, uomString)}
                              currentIndex={i}

                            />
                          </div>
                          : null
                      }
                      <FormSwitch
                        label='Add Price Range'
                        labelPosition={'before'}
                        labelTitleClass="switchLabel"
                        className='input-row label-row'
                        onClick={() => toggleChange(!item.showPriceRange, i)}
                        checked={item.showPriceRange}
                        showToggleStatus={false}
                      />
                    </div>
                  </div>
                  {!isReadOnly && <div className={styles["delete-btn-holder"]}>
                    <Button
                      variant="default"
                      className={styles["delete-btn"]}
                      clickHandler={() => handleSubmit(false, i)}>
                      Don't Update Price
                    </Button>
                    <Button
                      variant="default"
                      className={styles["delete-btn"]}
                      clickHandler={() => handleSubmit(true, i)}>
                      Update Price
                    </Button>
                  </div>}
                </div>
              )
            }) : <NoProductFound
              twoLineText={true}
              labelOne={`No ${session?.profileObject?.PluralLabelWithSpace} Found with`}
              labelTwo="Outdated Pricing Information"
              isBtn={true}
              btnTxt={`View All ${session?.profileObject?.PluralLabelWithSpace}`}
              btnClick={closeSlider}
            />
          }
          <UOMSliderWrapper
            ref={sliderRef}
            uomType={session?.newProfile === 3 ? 'serviceUOM' : 'productUOM'}
            onSelectUOM={onSelectUOM}
            showUOMType={"Packed"}
            isHideStds={prodData[currentSelectedForUom]?.categoryType.toLowerCase() == "service"}
            isProduct={prodData[currentSelectedForUom]?.categoryType.toLowerCase() == "product"}
            fromAddPrice={true}
            fromAddPricePriceRange={prodData[currentSelectedForUom]?.showPriceRange}
            productUnderEdit={productUnderEdit}
          />
        </div>}
    </SliderWrapper>
  )
}

export default OutDatedPriceCard